import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.link.js";
import { upload } from '@/services/common';
import { getNewsDetail as _getNewsDetail, saveNews, getNewsCategory as _getNewsCategory } from '@/services/news';
import { getProductList } from '@/services/productDetail.js';
import erpProductMixin from '@/utils/vue-functions/erpProductMixin';
import TinymceEditor from '@/components/tinymce';
import FooterToolBar from '@/components/tool/FooterToolBar';
import Result from '@/components/result/Result';
import selectProduct from '@/components/commonAdd/selectGroupGoods.vue';
export default {
  components: {
    TinymceEditor: TinymceEditor,
    FooterToolBar: FooterToolBar,
    Result: Result,
    selectProduct: selectProduct
  },
  i18n: require('./i18n-news'),
  mixins: [erpProductMixin],
  data: function data() {
    return {
      formData: {
        title: '',
        categoryList: [],
        newsContentType: 1,
        content: '',
        link: '',
        productList: []
      },
      rules: {
        title: [{
          required: true,
          message: this.$t('newsDetail.titleError'),
          trigger: 'blur'
        }],
        newsContentType: [{
          required: true
        }],
        content: [{
          required: true,
          message: this.$t('newsDetail.contentError'),
          trigger: 'blur'
        }],
        link: [{
          required: true,
          message: this.$t('newsDetail.linkError'),
          trigger: 'blur'
        }]
      },
      submitLoading: false,
      showSuccess: false,
      categoryList: [],
      isTableLoading: false,
      queryParam: {
        page: 1,
        size: 5
      },
      crrentPageProductList: [],
      selectedRowKeys: [],
      selectProductList: [],
      productOptionIdList: [],
      removeTypeVisible: false,
      modalValue: {
        removeType: 0
      }
    };
  },
  computed: {
    columns: function columns() {
      return [{
        title: this.$t('publicuse.goodsno'),
        dataIndex: 'productNo',
        key: 'productNo',
        width: '20%',
        align: 'left'
      }, {
        dataIndex: 'goodsName',
        title: this.$t('publicuse.goodsname'),
        key: 'goodsName',
        width: '40%',
        scopedSlots: {
          customRender: 'goodsName' //自定义表格里面的内容
        },
        ellipsis: true,
        align: 'left'
      }, {
        title: this.$t('publicuse.status'),
        dataIndex: 'status',
        key: 'status',
        width: '20%',
        align: 'center',
        scopedSlots: {
          customRender: 'status'
        }
      }, {
        title: this.$t('newsDetail.inventoryquantity'),
        dataIndex: 'productStocknum',
        key: 'productStocknum',
        width: '10%',
        align: 'right'
      }, {
        title: this.$t('publicuse.action'),
        dataIndex: 'action',
        key: 'action',
        width: '20%',
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center'
      }];
    }
  },
  mounted: function mounted() {
    this.getNewsCategory();
    this.$route.query.id && this.getNewsDetail();
  },
  methods: {
    getNewsDetail: function getNewsDetail() {
      var _this = this;
      _getNewsDetail({
        id: this.$route.query.id
      }).then(function (res) {
        if (res.data.code == 200) {
          var result = res.data.data;
          result.title = _.unescape(result.title);
          result.categoryList = result.categoryList && result.categoryList.map(function (item) {
            return item.categoryId;
          });
          result[result.newsContentType == 0 ? 'link' : 'content'] = result.newsContent;
          Object.assign(_this.formData, result);
          if (_this.formData.productIds && _this.formData.productIds.length) {
            _this.productOptionIdList = _this.formData.productIds;
            getProductList({
              condition: {},
              productOpitonIdStr: _this.formData.productIds.join(',')
            }).then(function (res) {
              if (res.data.code == 200) {
                _this.formData.productList = res.data.data.list;
                _this.calcCurrentPageProductList();
              }
            });
          }
        }
      });
    },
    getNewsCategory: function getNewsCategory() {
      var _this2 = this;
      _getNewsCategory().then(function (res) {
        if (res.data.code == 200) {
          _this2.categoryList = res.data.data.list || [];
        }
      });
    },
    imgUpload: function imgUpload(blobInfo, success, failure) {
      var formData = new FormData();
      formData.append('type', 8);
      formData.append('file', blobInfo.blob(), blobInfo.filename());
      upload(formData).then(function (res) {
        if (res.data.code == 200) {
          success(res.data.data.urlpath + res.data.data.uploadfilepath);
        }
      });
    },
    showAddProductModal: function showAddProductModal() {
      this.$refs.selectModal.visible = true;
    },
    confirmProduct: function confirmProduct(data) {
      this.formData.productList = data;
      this.productOptionIdList = this.formData.productList.map(function (item) {
        return item.optionId;
      });
      this.calcCurrentPageProductList();
    },
    onSelectChange: function onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectProductList = this.formData.productList.filter(function (item) {
        return selectedRowKeys.includes(item.optionId);
      });
    },
    tableChange: function tableChange(pagination, filters, sorter, _ref) {
      var currentDataSource = _ref.currentDataSource;
      this.queryParam.page = pagination.current;
      this.queryParam.size = pagination.pageSize;
      this.calcCurrentPageProductList();
    },
    calcCurrentPageProductList: function calcCurrentPageProductList() {
      var start = this.queryParam.page >= 1 ? (this.queryParam.page - 1) * this.queryParam.size : 0;
      this.crrentPageProductList = this.formData.productList.slice(start, start + this.queryParam.size);
    },
    showRemoveModal: function showRemoveModal() {
      this.modalValue.removeType = 0;
      this.removeTypeVisible = true;
    },
    removeProduct: function removeProduct(record) {
      this.removeErpCustomers(record);
      this.removeTypeVisible = false;
    },
    formSubmit: function formSubmit() {
      var _this3 = this;
      this.$refs.newsDetailForm.validate(function (valid) {
        if (valid) {
          var params = {
            id: _this3.$route.query.id,
            title: _.escape(_this3.formData.title),
            contentType: _this3.formData.newsContentType,
            categoryIds: _this3.formData.categoryList.length ? _this3.formData.categoryList : undefined,
            content: _this3.formData.newsContentType == 0 ? _this3.formData.link : _this3.formData.content,
            productIds: _this3.formData.productList.length ? _this3.formData.productList.map(function (item) {
              return item.optionId;
            }) : undefined
          };
          _this3.submitLoading = true;
          saveNews(params).then(function (res) {
            if (res.data.code == 200) {
              if (_this3.$route.query.id) {
                _this3.$message.success(_this3.$t('public.updateSuccessfully'));
              } else {
                _this3.$refs.newsDetailForm.resetFields();
                _this3.formData.productList = [];
                _this3.formData.categoryList = [];
                _this3.showSuccess = true;
              }
            }
          }).finally(function () {
            _this3.submitLoading = false;
          });
        }
      });
    },
    createAgain: function createAgain() {
      this.showSuccess = false;
    },
    backList: function backList() {
      this.$router.replace({
        name: 'NewsList'
      });
    }
  }
};